import { Select, SelectProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { useGetProductQualitiesQuery } from 'services/ecommerceApi';

interface Props extends SelectProps<number | ''> {
  allowEmpty?: boolean;
}
export default function ProductQualitiesSelect({
  allowEmpty = false,
  ...props
}: Props) {
  const { t } = useTranslation();

  const { data: productQualities, isLoading } = useGetProductQualitiesQuery();

  return (
    <Select
      showSearch
      allowClear
      loading={isLoading}
      placeholder={t('generals.selectPlaceholder')}
      optionFilterProp="children"
      filterOption
      {...props}
    >
      {allowEmpty ? (
        <Select.Option key="all" value="">
          Todas
        </Select.Option>
      ) : null}
      {productQualities?.map((productQuality) => (
        <Select.Option key={productQuality.id} value={productQuality.id}>
          {productQuality.description}
        </Select.Option>
      ))}
    </Select>
  );
}
